import React from 'react';
import PropTypes from 'prop-types';
import { mapCreatorConnect } from '../../higher-order-components';
import {
  Modal,
  Row,
  Col,
  Button,
  FormControl,
  ControlLabel
} from 'react-bootstrap';
import { SingleFileUploadButton, LoadingSpinner } from 'components';

class MarkerEditorInfoWindowModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      info_window_text: ''
    };

    this.getAddInfoWindowButtonContents = this.getAddInfoWindowButtonContents.bind(this);
    this.getEditInfoWindowButtonContents = this.getEditInfoWindowButtonContents.bind(this);
    this.getInfoWindowImageSrc = this.getInfoWindowImageSrc.bind(this);
    this.handleOnHide = this.handleOnHide.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  getAddInfoWindowButtonContents() {
    const { uploading_info_window_image } = this.props.mapCreator;
    if(uploading_info_window_image) {
      return <LoadingSpinner size={2} />;
    }
    else {
      return 'Add Image';
    }
  }
  getEditInfoWindowButtonContents() {
    const { uploading_info_window_image } = this.props.mapCreator;
    if(uploading_info_window_image) {
      return <LoadingSpinner size={2} />;
    }
    else {
      return 'Change Image';
    }
  }
  getInfoWindowImageSrc() {
    const { current_feature_saved, tmp_info_window_image_file } = this.props.mapCreator;
    if(tmp_info_window_image_file) {
      return tmp_info_window_image_file.url;
    }
    else if(current_feature_saved.properties.info_window_image_file) {
      return current_feature_saved.properties.info_window_image_file.url;
    }
    else {
      return null;
    }
  }
  handleOnHide() {
    this.props.cancelUpdateMapCreatorInfoWindow();
  }
  handleSave() {
    const { current_feature, tmp_info_window_image_file, current_map } = this.props.mapCreator;
    const updated_props = {
      ...current_feature.properties,
      info_window_text: this.state.info_window_text,
      info_window_image_file: tmp_info_window_image_file || current_feature.properties.info_window_image_file
    };
    this.props.updateCurrentMapFeature({ ...current_feature, properties: updated_props }, current_map._id);
  }
  componentDidUpdate(prev_props) {
    const prev_show = prev_props.mapCreator.show_marker_editor_info_window_modal;
    const curr_show = this.props.mapCreator.show_marker_editor_info_window_modal;
    if(prev_show == false && curr_show == true) {
      const { current_feature_saved } = this.props.mapCreator;
      this.setState({
        info_window_text: current_feature_saved.properties.info_window_text,
      });
    }
    else if(prev_show == true && curr_show == false) {
      this.setState({ info_window_text: '' });
    }
  }

  render() {
    const {
      show_marker_editor_info_window_modal,
      tmp_info_window_image_file,
      current_feature_saved
    } = this.props.mapCreator;
    return (
      <Modal
        show={show_marker_editor_info_window_modal}
        onHide={this.handleOnHide}
        bsSize='small'
        >
        <Modal.Header>Edit Info Window</Modal.Header>
        <Modal.Body>
          <Row className='mb-md'>
            <Col xs={12} md={12}>
              <ControlLabel htmlFor='map-creator-info-window-text'>Text</ControlLabel>
              <FormControl
                value={this.state.info_window_text}
                onChange={e => this.setState({ info_window_text: e.target.value })}
                id='map-creator-info-window-text'
                placeholder='Enter Info Window Text'
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={12}>
              {this.getInfoWindowImageSrc() ? (
                <div>
                  <img src={this.getInfoWindowImageSrc()} style={{maxWidth: '267px'}}/>
                  <SingleFileUploadButton
                    block={true}
                    button_contents={this.getEditInfoWindowButtonContents()}
                    onDrop={this.props.uploadMapCreatorInfoWindowImage}
                  />
                </div>
              ) : (
                <div>
                  <p>No Image</p>
                  <SingleFileUploadButton
                    block={true}
                    button_contents={this.getAddInfoWindowButtonContents()}
                    onDrop={this.props.uploadMapCreatorInfoWindowImage}
                  />
                </div>
              )}
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Row>
            <Col xs={6} md={6}>
              <Button block onClick={this.handleOnHide}>Cancel</Button>
            </Col>
            <Col xs={6} md={6}>
              <Button block bsStyle='primary' onClick={this.handleSave}>Save</Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default mapCreatorConnect(MarkerEditorInfoWindowModal);



// WEBPACK FOOTER //
// ./src/browser/components/map-creator/marker-editor-info-window-modal.js